import { Button, Card, Collapse, Tabs } from "antd";
import React, { lazy, Suspense, useState } from "react";
import useMedia from "use-media";
import { SwitchYesNo } from "~/components/form/SwitchYesNo.jsx";
import { GFlex } from "~/components/GFlex.jsx";
import { $t, i18n } from "~/i18n.js";
import { AanmeldList } from "./AanmeldList.jsx";
import { CardKisten } from "./cardKisten.jsx";
import { CardRollen } from "./cardRollen.jsx";
import { CardRooster } from "./cardRooster.jsx";
import { MessageCard } from "./messageCard.jsx";
import { RecencyWarnings } from "./RecencyWarnings.jsx";
import { CardOverland } from "./cardOverland.jsx";
import { VoucherCard } from "~/components/voucher/VoucherCard.jsx";
import { VoucherModal } from "~/components/voucher/VoucherModal.jsx";
import { CardRegistrationList } from "./cardRegistrationList.jsx";
import { AuthoriseStudent } from "~/components/authorise/AuthoriseStudent.jsx";
import { Topmeteo } from "~/components/topmeteo/topmeteo.jsx";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import { EnvironmentOutlined, TableOutlined } from "@ant-design/icons";
import { Radio } from "antd";

import { Spin } from "antd";
import { colors } from "~/theme/colors.js";

const UserMapView = lazy(() => import("~/components/userMap/UserMapView.jsx"));

export const AanmeldLijstContent = ({
  days,
  aanmeldingen,
  club,
  flights,
  profile,
  currentAanmelding,
  setOpenPilot,
  editAanmelding,
  afmelden,
  vouchers,
}) => {
  const [viewAsInstructor, setViewAsInstructor] = useState(false);
  const isVliegend = days.activeDay.is_vliegend;
  const [viewMode, setViewMode] = useState("list");

  // Authorization modal state
  const [selectedAuthorizationAanmeldingen, setAuthorizationAanmeldingen] =
    useState([]);
  const [authoriseModalVisible, setAuthoriseModalVisible] = useState(false);

  const canAuthorize =
    club?.enable_authorization && profile?.allow_give_authorisation;

  const isWide = useMedia({ minWidth: "1350px" }, true);
  const topMeteo = aanmeldingen.topmeteo || {};

  const overlandVliegers = aanmeldingen.aanmeldingen
    .filter((a) => a.aangemeld && a.overland && !a.kist.includes("privé"))
    .map((a) => ({
      ...a,
      last_xc: a.vlieger?.recency?.last_xc
        ? new Date(a.vlieger?.recency?.last_xc)
        : null,
    }))
    .sort((a, b) => {
      if (a.last_xc === null && b.last_xc === null) return 0;
      if (a.last_xc === null) return -1;
      if (b.last_xc === null) return 1;
      return a.last_xc - b.last_xc;
    });

  const [openVoucherData, setOpenVoucherData] = useState(null);

  return (
    <>
      {selectedAuthorizationAanmeldingen.length > 0 && (
        <AuthoriseStudent
          aanmeldingen={selectedAuthorizationAanmeldingen}
          visible={selectedAuthorizationAanmeldingen.length > 0}
          onClose={() => setAuthorizationAanmeldingen([])}
        />
      )}

      <GFlex style={{ marginTop: 12 }}>
        {isWide && (
          <GFlex c="column" style={{ maxWidth: 300 }}>
            {isVliegend && topMeteo && Object.keys(topMeteo).length > 0 && (
              <Card size="small" title={$t("Topmeteo")}>
                <Topmeteo topmeteoData={topMeteo} unit={i18n.height_unit} />
              </Card>
            )}

            {isVliegend && (
              <Card size="small" title={$t("Rollen")}>
                <CardRollen
                  aanmeldingen={aanmeldingen}
                  groups_aanmeld={club.groups_aanmeld}
                  group_name_lookup={flights.group_name_lookup}
                />
              </Card>
            )}

            {aanmeldingen.diensten?.length > 0 && (
              <Card size="small" title={$t("Diensten")}>
                <CardRooster
                  diensten={aanmeldingen.diensten}
                  user={profile}
                  openAanmelding={() =>
                    !currentAanmelding && editAanmelding({})
                  }
                />
              </Card>
            )}

            {aanmeldingen.registration_lists?.length > 0 && (
              <Card size="small" title={$t("Lijsten")}>
                <CardRegistrationList
                  setOpenPilot={setOpenPilot}
                  n_instructors={aanmeldingen.n_instructors}
                  aanmeldingen={aanmeldingen?.aanmeldingen}
                  registration_lists={aanmeldingen.registration_lists}
                  currentUser={profile}
                  currentAanmelding={currentAanmelding}
                />
              </Card>
            )}

            {isVliegend && (
              <Card size="small" title={$t("Kisten")}>
                <CardKisten aanmeldingen={aanmeldingen} day={days.activeDay} />
              </Card>
            )}

            {isVliegend && overlandVliegers.length > 0 && (
              <Card size="small" title={$t("Overland")}>
                <CardOverland overlandVliegers={overlandVliegers} />
              </Card>
            )}

            {vouchers.length > 0 && (
              <Card size="small" title={$t("Vouchers")}>
                <VoucherCard
                  vouchers={vouchers}
                  openVoucher={setOpenVoucherData}
                />
              </Card>
            )}
          </GFlex>
        )}

        <div>
          <div>
            {!isWide && (isVliegend || aanmeldingen?.diensten?.length > 0) && (
              <Tabs
                style={{
                  background: "white",
                  paddingLeft: 6,
                  paddingBottom: 6,
                  marginBottom: 12,
                  maxWidth: 750,
                }}
                defaultActiveKey="message"
                items={[
                  aanmeldingen.diensten?.length > 0 && {
                    label: $t("Diensten"),
                    key: "diensten",
                    children: (
                      <CardRooster
                        diensten={aanmeldingen.diensten}
                        user={profile}
                        openAanmelding={() =>
                          !currentAanmelding && editAanmelding({})
                        }
                      />
                    ),
                  },

                  aanmeldingen.registration_lists?.length > 0 && {
                    label: $t("Lijsten"),
                    key: "lijsten",
                    children: (
                      <CardRegistrationList
                        setOpenPilot={setOpenPilot}
                        n_instructors={aanmeldingen.n_instructors}
                        aanmeldingen={aanmeldingen?.aanmeldingen}
                        registration_lists={aanmeldingen.registration_lists}
                        currentUser={profile}
                        currentAanmelding={currentAanmelding}
                      />
                    ),
                  },
                  isVliegend && {
                    label: $t("Rollen"),
                    key: "rollen",
                    children: (
                      <CardRollen
                        aanmeldingen={aanmeldingen}
                        groups_aanmeld={club.groups_aanmeld}
                        group_name_lookup={flights.group_name_lookup}
                      />
                    ),
                  },
                  vouchers.length > 0 && {
                    label: $t("Vouchers"),
                    key: "vouchers",
                    children: <VoucherCard vouchers={vouchers} />,
                  },
                  isVliegend && {
                    label: $t("Kisten"),
                    key: "kisten",
                    children: (
                      <CardKisten
                        aanmeldingen={aanmeldingen}
                        day={days.activeDay}
                      />
                    ),
                  },

                  isVliegend &&
                    overlandVliegers.length > 0 && {
                      label: $t("Overland"),
                      key: "xc",
                      children: (
                        <CardOverland overlandVliegers={overlandVliegers} />
                      ),
                    },

                  isVliegend &&
                    topMeteo &&
                    Object.keys(topMeteo).length > 0 && {
                      label: $t("Topmeteo"),
                      key: "topmeteo",
                      children: (
                        <Topmeteo
                          topmeteoData={topMeteo}
                          unit={i18n.height_unit}
                        />
                      ),
                    },
                ]}
              />
            )}

            {club?.enable_authorization && currentAanmelding && (
              <>
                <Collapse
                  key={
                    currentAanmelding.authorised
                      ? "authorised"
                      : "not-authorised"
                  }
                  defaultActiveKey={
                    currentAanmelding.authorised?.limitations ? ["1"] : []
                  }
                  style={{ marginBottom: 12, maxWidth: 750 }}
                  items={[
                    {
                      key: "1",
                      label: (
                        <div className="row" style={{ gap: 6 }}>
                          <SafetyCertificateOutlined
                            style={{
                              color: currentAanmelding.authorised
                                ? colors.groen
                                : colors.orange,
                            }}
                          />
                          <span>
                            {currentAanmelding.authorised
                              ? $t("Geautoriseerd")
                              : $t("Nog niet geautoriseerd")}
                          </span>
                        </div>
                      ),
                      children: currentAanmelding.authorised ? (
                        <div>
                          {currentAanmelding.authorised.limitations && (
                            <p style={{marginBottom: 8 }}>
                              <span className="label">{$t("Beperkingen")}</span>
                              <span style={{ marginLeft: 8 }}>
                                {currentAanmelding.authorised.limitations}
                              </span>
                            </p>
                          )}
                          <p className="small gray">
                            {currentAanmelding.authorised.name}
                          </p>
                        </div>
                      ) : aanmeldingen.is_today ? (
                        <div >
                          <p className="small gray" style={{ marginBottom: 12 }}>
                            {$t(
                              "Je bent vandaag nog niet geautoriseerd. Vraag een instructeur om je te autoriseren.",
                            )}
                          </p>
                          <Button
                            size="small"
                            type="primary"
                            onClick={() => setAuthoriseModalVisible(true)}
                          >
                            {$t("Autoriseer")}
                          </Button>
                        </div>
                      ) : (
                        <p className="small gray">
                          {$t(
                            "Autorisatie is alleen mogelijk op de vliegdag zelf.",
                          )}
                        </p>
                      ),
                    },
                  ]}
                />
                {!currentAanmelding.authorised && aanmeldingen.is_today && (
                  <AuthoriseStudent
                    aanmeldingen={[currentAanmelding]}
                    visible={authoriseModalVisible}
                    signAsStudent={!profile.allow_give_authorisation}
                    onClose={() => setAuthoriseModalVisible(false)}
                  />
                )}
              </>
            )}

            <div
              style={{
                maxWidth: 750,
                maxHeight: 400,
                marginBottom: 16,
                overflowY: "auto",
              }}
            >
              <MessageCard
                messages={aanmeldingen.messages}
                canEditMessage
                currentUserID={profile.id}
              />
            </div>

            {isVliegend && profile.is_instructeur && (
              <div className="row" style={{ marginBottom: 16, gap: 12 }}>
                <p>{$t("Bekijk instructie informatie:")}</p>
                <SwitchYesNo
                  value={viewAsInstructor}
                  onChange={setViewAsInstructor}
                />
              </div>
            )}

            {isVliegend && profile.is_instructeur && (
              <RecencyWarnings
                setOpenPilot={setOpenPilot}
                aanmeldingen={aanmeldingen.aanmeldingen}
                profile={profile}
                enableAuthorization={club?.enable_authorization}
                canAuthorize={canAuthorize}
                setAuthorizationAanmeldingen={setAuthorizationAanmeldingen}
              />
            )}

            {!profile.private_mode && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: 8,
                  maxWidth: 750,
                }}
              >
                <Radio.Group
                  key="view-toggle"
                  size="small"
                  value={viewMode}
                  onChange={(e) => setViewMode(e.target.value)}
                  options={[
                    {
                      value: "list",
                      label: (
                        <p>
                          <TableOutlined />
                          {$t("Lijst")}
                        </p>
                      ),
                    },
                    {
                      value: "map",
                      label: (
                        <p>
                          <EnvironmentOutlined />
                          {$t("Kaart")}
                        </p>
                      ),
                    },
                  ]}
                  optionType="button"
                  buttonStyle="solid"
                />
              </div>
            )}

            {viewMode === "list" && (
              <AanmeldList
                aanmeldingen={aanmeldingen.aanmeldingen}
                profile={profile}
                afmelden={afmelden}
                notities={aanmeldingen.notities}
                bevoegdheden={aanmeldingen.bevoegdheden}
                viewInstructorInfo={viewAsInstructor}
                setOpenPilot={setOpenPilot}
                isVliegend={isVliegend}
                groups_aanmeld={club.groups_aanmeld}
                group_name_lookup={flights.group_name_lookup}
                enableAuthorization={club?.enable_authorization}
                canAuthorize={canAuthorize}
                setAuthorizationAanmeldingen={setAuthorizationAanmeldingen}
              />
            )}

            {viewMode === "map" && (
              <Suspense fallback={<Spin style={{ margin: 24 }} />}>
                <UserMapView
                  listVliegers={aanmeldingen.aanmeldingen
                    .filter((v) => v && v.vlieger && v.aangemeld)
                    .map((v) => v.vlieger)}
                  club={club}
                  openUser={setOpenPilot}
                />
              </Suspense>
            )}
          </div>
        </div>
      </GFlex>

      <VoucherModal
        open={!!openVoucherData}
        voucher={openVoucherData}
        onClose={() => setOpenVoucherData(null)}
      />
    </>
  );
};
